import { render, staticRenderFns } from "./AttachCombo.vue?vue&type=template&id=c552fa1a&"
import script from "./AttachCombo.vue?vue&type=script&lang=js&"
export * from "./AttachCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports